import { AxiosInstance } from 'axios'
import { AuditLog, AuditLogCreate, ListAuditLogsParams, PaginatedAuditLogResponse } from './audit-log.type'

const serializeParams = (params: Record<string, any>): string => {
    const searchParams = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) return
        if (Array.isArray(value)) {
            value.forEach(v => searchParams.append(key, v))
        } else {
            searchParams.append(key, String(value))
        }
    })
    return searchParams.toString()
}

export class AuditLogApi {
    constructor(private readonly client: AxiosInstance) {}

    async create(payload: AuditLogCreate): Promise<AuditLog> {
        const response = await this.client.post<AuditLog>('/audit-logs', payload)
        return response.data
    }

    /**
     * Get all audit logs with pagination and filters
     */
    async list(params?: ListAuditLogsParams): Promise<PaginatedAuditLogResponse> {
        const response = await this.client.get<PaginatedAuditLogResponse>('/audit-logs', {
            params,
            paramsSerializer: serializeParams,
        })
        return response.data
    }

    /**
     * Get a single audit log by ID
     */
    async findOne(id: string): Promise<AuditLog> {
        const response = await this.client.get<AuditLog>(`/audit-logs/${id}`)
        return response.data
    }

    /**
     * Export audit logs as CSV
     * @param params - Query parameters for filtering (same as list)
     * @returns Blob of CSV file
     */
    async exportCsv(params?: ListAuditLogsParams): Promise<Blob> {
        const response = await this.client.get('/audit-logs/export-csv', {
            params,
            paramsSerializer: serializeParams,
            responseType: 'blob',
        })
        return response.data
    }
}
